import { Dispatch } from 'redux';
import { Validator } from 'redux-form';
import { clearWarningText, setWarningText } from '../ducks/viewer';
import { portalService } from '../services/portalService';
import { extractErrorProps } from './errorUtils';

export const required: Validator = (value: string) => {
  if (value) {
    return value.length > 0 ? undefined : 'Required';
  }
  return 'Required';
};

export const requiredGroupName: Validator = (value: string) => {
  if (!value) {
    return 'Required';
  }

  if (value.indexOf('(') > -1 || value.indexOf(')') > -1) {
    return 'Characters not allowed: ()';
  }

  return undefined;
};

export const requiredZerosOK: Validator = (value) => (value || value === '0' || value === 0 ? undefined : 'Required');

export const passwordValidation: Validator = (value: string) => {
  const requiredError = required(value);
  if (requiredError !== undefined) {
    return requiredError;
  }

  if (value.length < 6) {
    return 'The password has to contain at least 6 characters';
  }

  return undefined;
};

export const emailValidation: Validator = async (value: any, dispatch: Dispatch) => {
  if (value.NEW_USER) {
    let validationMessage: { message: string };
    dispatch(clearWarningText());
    try {
      validationMessage = await portalService.validateUser(value.EMAIL, value.GROUP_ID, value.DEALERS);

      if (validationMessage.message) {
        dispatch(setWarningText(validationMessage.message));
      }
    } catch (error) {
      const { errorMessage = 'Error occurred while validating email address', status } = extractErrorProps(error);
      if (status === 409) {
        // eslint-disable-next-line no-throw-literal
        throw { EMAIL: errorMessage };
      }

      // eslint-disable-next-line no-console
      console.error('Email validation failed: ', errorMessage);
      // eslint-disable-next-line no-throw-literal
      throw { EMAIL: 'Please provide a valid email address' };
    }
  }
  return undefined;
};
